import * as React from 'react';
/**
 *
 * Original name: flag
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A349
 *
 */
export const FlagPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M36.838 18.792a2 2 0 0 1-2.015-1.292l-.978-2.605A6.028 6.028 0 0 0 28.228 11H14v45h4V38h10.228a2.009 2.009 0 0 1 1.872 1.3l.978 2.605a6.04 6.04 0 0 0 6.045 3.878L50 44.862v-27.01l-13.162.94ZM46 41.138l-9.162.654a2 2 0 0 1-2.015-1.292l-.978-2.605A6.028 6.028 0 0 0 28.228 34H18V15h10.228a2.009 2.009 0 0 1 1.872 1.3l.978 2.605a6.031 6.031 0 0 0 6.045 3.878L46 22.148v18.99Z", fill: "currentColor" })));
